var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.42 9.83332C14.42 10.4267 14.2533 10.9867 13.96 11.4667C13.4133 12.3867 12.4067 13 11.2533 13C10.1 13 9.09334 12.38 8.54667 11.4667C8.25334 10.9933 8.08667 10.4267 8.08667 9.83332C8.08667 8.08666 9.50667 6.66666 11.2533 6.66666C13 6.66666 14.42 8.08666 14.42 9.83332Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4399 9.81998H10.0732",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2532 8.66666V11.0333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7935 2.68002V4.16C13.7935 4.7 13.4535 5.37335 13.1201 5.71335L11.9468 6.74667C11.7268 6.69334 11.4935 6.66668 11.2535 6.66668C9.50679 6.66668 8.08679 8.08668 8.08679 9.83334C8.08679 10.4267 8.25345 10.9867 8.54679 11.4667C8.79345 11.88 9.13345 12.2333 9.54679 12.4867V12.7133C9.54679 13.12 9.28012 13.66 8.94012 13.86L8.00012 14.4667C7.12679 15.0067 5.91345 14.4 5.91345 13.32V9.75335C5.91345 9.28001 5.64012 8.67335 5.37345 8.34002L2.81345 5.64666C2.48012 5.30666 2.20679 4.70002 2.20679 4.30002V2.74667C2.20679 1.94001 2.81345 1.33334 3.55345 1.33334H12.4468C13.1868 1.33334 13.7935 1.94002 13.7935 2.68002Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAdd);
export default __webpack_public_path__ + "static/media/filter-add.cfee0dac505556cbd41b5eb7fbb39b79.svg";
export { ForwardRef as ReactComponent };